<template>
	<div class="general-avaliability">
		<div
			v-for="(room, indexDay) in freeRooms"
			:key="indexDay"
			:class="[
				'col-calendar',
				'col-calendar-1',
				ceroValue(room.free) ? 'red-value' : null,
				]"
			@click="selectedDate(indexDay, flagActiveDate)"
		>
			<p
				:class="[
				'avaliability-date',
				firstDateSelected(indexDay) ? 'highlight-date' : null,
				rangeSelected(indexDay, rangeDate) ? 'highlight-date' : null,
				initRangeDate(indexDay, rangeDate) ? 'border-radius-left' : null,
				endRangeDate(indexDay, rangeDate) ? 'border-radius-right' : null,
				]"
			>
				{{room.availabilities}}
			</p>
		</div>
		<avaliability-modal
			v-if="showAvaliabilityModal"
			:calculate-position="rangeDate[0]"
			:rooms-type="typesRooms"
			:init-date="initDate"
			:end-date="endDate"
			:total-nights="totalNights"
			:is-loading="isLoading"
			:subsidiary="subsidiaryId"
		/>
	</div>
</template>

<script>
import helper from '@/shared/helper';
import avaliabilityModal from './../utils/AvaliabilityModal';

const { formatDate } = helper.methods;

function showAvaliabilityModal() {
	const showModal = this.rangeDate.length > 0;
	if (showModal) {
		this.isLoading = true;
		const initDate = this.monthSelected.days[this.rangeDate[0]].date;
		this.initDate = formatDate(initDate, 'YYYY-MM-DD');
		const endDate = this.monthSelected.days[this.rangeDate[1]].date;
		this.endDate = formatDate(endDate, 'YYYY-MM-DD');
		this.getGeneralAvaliabilityInfo(this.initDate, this.endDate, this.subsidiaryId);
	}
	return showModal;
}

async function getGeneralAvaliabilityInfo(checkIn, checkOut, idSubsidiary) {
	const url = `${process.env.PMS_URL}/availabilities/by-roomtypes`;
	const params = {
		checkIn,
		checkOut,
		idSubsidiary,
	};
	const { data: result } = await this.$http.get(url, { params });
	this.typesRooms = result.data.roomTypes;
	this.totalNights = result.data.days;
	this.isLoading = false;
}

function initRangeDate(index, range) {
	return range[0] === index;
}

function endRangeDate(index, range) {
	return range[1] === index;
}

function rangeSelected(index, range) {
	return index >= range[0] && index <= range[1];
}

function firstDateSelected(index) {
	return this.clickOne === index;
}

function resetClicks() {
	this.clickOne = null;
	this.clickTwo = null;
}

function buildRangeDate(init, end) {
	this.rangeDate = init <= end ? [init, end] : [end, init];
	this.resetClicks();
}

function selectedDate(index, flag) {
	if (!flag) {
		this.rangeDate = [];
		this.clickOne = index;
	} else {
		this.clickTwo = index;
	}
	if (this.clickOne !== null && this.clickTwo !== null) {
		this.buildRangeDate(this.clickOne, this.clickTwo);
	}
	this.flagActiveDate = !this.flagActiveDate;
}

function ceroValue(value) {
	return value === 0;
}

function data() {
	return {
		clickTwo: null,
		clickOne: null,
		endDate: '',
		flagActiveDate: false,
		initDate: '',
		isLoading: false,
		rangeDate: [],
		typesRooms: [],
		totalNights: '',
	};
}

export default {
	name: 'general-availability',
	components: {
		avaliabilityModal,
	},
	computed: {
		showAvaliabilityModal,
	},
	data,
	methods: {
		buildRangeDate,
		ceroValue,
		endRangeDate,
		firstDateSelected,
		getGeneralAvaliabilityInfo,
		initRangeDate,
		rangeSelected,
		resetClicks,
		selectedDate,
	},
	props: {
		freeRooms: {
			default: () => [],
			type: Array,
		},
		subsidiaryId: {
			default: 0,
			type: Number,
		},
		monthSelected: {
			default: () => {},
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>
	.general-avaliability {
		display: flex;
		position: relative;
		width: 100%;
	}

	.col-calendar {
		color: map-get($colors, default-green);
		cursor: pointer;
		display: table-cell;
		vertical-align: middle;
	}

	.col-calendar-1 {
		background-color: map-get($map: $colors, $key: header-dark);
		height: 36px;
		min-width: 43px;
		width: 100%;
	}

	.col-calendar-1:hover {
		opacity: 0.7;
	}

	.avaliability-date {
		align-items: center;
		display: flex;
		height: 100%;
		justify-content: center;
		margin: 0;
		width: 100%;
	}

	.selected-date {
		background-color: white;
	}

	.highlight-date {
		background-color: white;
	}

	.border-radius-right {
		border-radius: 0 50% 50% 0;
	}

	.border-radius-left {
		border-radius: 50% 0 0 50%;
	}
</style>



// WEBPACK FOOTER //
// GeneralAvailability.vue?470022ed